module.exports = __webpack_public_path__ + "img/level3.c11f5fcf.png";